module.exports = __webpack_public_path__ + "img/swiper1_1.c760661b.webp";